import { render, staticRenderFns } from "./CompanyOverview.vue?vue&type=template&id=2b1478b7&scoped=true&"
import script from "./CompanyOverview.vue?vue&type=script&lang=js&"
export * from "./CompanyOverview.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOverview.vue?vue&type=style&index=0&id=2b1478b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1478b7",
  null
  
)

export default component.exports